import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo-500.png'


const _hoisted_1 = { class: "hold-transition login-page" }
const _hoisted_2 = { id: "login-ui" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    id: "logo-image",
    src: _imports_0,
    alt: "帳票テンプレート"
  })
], -1)
const _hoisted_4 = { class: "login-box" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = { class: "card-body login-card-body" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user" })
  ])
], -1)
const _hoisted_9 = { class: "input-group mb-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-lock" })
  ])
], -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, null, -1)
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = {
  key: 0,
  id: "notice-list",
  class: "mt-5"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-bullhorn" }),
  /*#__PURE__*/_createTextVNode(" お知らせ ")
], -1)
const _hoisted_16 = {
  class: "accordion",
  id: "notice-accordion"
}
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "mb-0" }
const _hoisted_19 = ["data-target", "textContent", "aria-controls"]
const _hoisted_20 = ["id", "aria-labelledby"]
const _hoisted_21 = { class: "card-body" }
const _hoisted_22 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_dismissible_alert = _resolveComponent("dismissible-alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("form", null, [
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  name: "username",
                  placeholder: "ログインID",
                  autocomplete: "current-password",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginId) = $event)),
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.tryLogin && _ctx.tryLogin(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.loginId]
                ]),
                _hoisted_8
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  class: "form-control",
                  name: "password",
                  placeholder: "パスワード",
                  autocomplete: "current-password",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.tryLogin && _ctx.tryLogin(...args)), ["enter"]))
                }, null, 544), [
                  [_vModelText, _ctx.password]
                ]),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_loading_button, {
                    color: "primary",
                    loading: _ctx.loading,
                    onClick: _ctx.tryLogin
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("ログイン")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"])
                ])
              ])
            ]),
            _createVNode(_component_dismissible_alert, {
              color: "danger",
              class: "mt-3",
              message: _ctx.errorMessage,
              onDismiss: _cache[4] || (_cache[4] = ($event: any) => (_ctx.errorMessage = null))
            }, null, 8, ["message"])
          ])
        ])
      ])
    ]),
    (_ctx.notices.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notices, (n) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card mb-0",
                key: n.noticeId
              }, [
                _createElementVNode("div", {
                  class: "card-header",
                  id: 'collapse-header-' + n.noticeId
                }, [
                  _createElementVNode("h5", _hoisted_18, [
                    _createElementVNode("button", {
                      class: "btn btn-link",
                      type: "button",
                      "data-toggle": "collapse",
                      "data-target": '#collapse-' + n.noticeId,
                      textContent: _toDisplayString(n.title),
                      "aria-controls": '#collapse-' + n.noticeId
                    }, null, 8, _hoisted_19)
                  ])
                ], 8, _hoisted_17),
                _createElementVNode("div", {
                  id: 'collapse-' + n.noticeId,
                  class: "collapse",
                  "data-parent": "#notice-accordion",
                  "aria-labelledby": '#collapse-header-' + n.noticeId
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("pre", {
                      textContent: _toDisplayString(n.detail)
                    }, null, 8, _hoisted_22)
                  ])
                ], 8, _hoisted_20)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}